import React from 'react'
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import FmdGoodIcon from '@mui/icons-material/FmdGood'
import { MotionCard, MotionIcon, MotionImage, MotionSection } from '../motion/Motion'

const items = [
  {
    title: 'Precision Engineering',
    icon: <PrecisionManufacturingIcon fontSize="small" className="text-white" />,
    imageSrc: '/images/sectionimages/Precision%20Engineering.jpg',
    body:
      'We utilize high-definition inlay and printing technologies (like HD Nylon and WaterHog) that prevent logo washout and fading, guaranteeing your brand remains vibrant for years.',
  },
  {
    title: 'Logistics Solved',
    icon: <LocalShippingIcon fontSize="small" className="text-white" />,
    imageSrc: '/images/sectionimages/Logistics%20Solved.jpg',
    body:
      'We manage all complex logistics, shipping, and duty payments, translating directly to faster delivery times (often cutting regional lead times by more than half) and stress-free procurement for you.',
  },
  {
    title: 'Local Focus',
    icon: <FmdGoodIcon fontSize="small" className="text-white" />,
    imageSrc: '/images/sectionimages/Local%20Focus.jpg',
    body:
      'Our operations are based in Zambia, offering local billing in ZMW, onsite consultation options, and support that understands the unique needs of the Zambian climate and commercial landscape.',
  },
]

export default function WhyWeAreDifferentSection() {
  return (
    <MotionSection className="w-full bg-[#ED3994] text-white py-12 lg:py-16 relative overflow-hidden">
      <div className="relative w-[96%] mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight">Why We Are Different</h2>
          <p className="mt-3 text-white/90 text-sm sm:text-base leading-relaxed">
            We don't just sell mats - we deliver a complete branded matting solution built for the realities of Zambia.
          </p>
        </div>

        <div className="mt-10 lg:mt-12">
          <div className="grid gap-8 lg:gap-10 lg:grid-cols-3">
            {items.map((item, index) => (
              <MotionCard key={item.title} className="w-full" delay={0.03 * index}>
                <div className="w-full h-44 sm:h-52 lg:h-56 overflow-hidden bg-black/10 relative">
                  <MotionImage className="absolute inset-0">
                    <img
                      src={item.imageSrc}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </MotionImage>

                  <div className="absolute top-3 left-3 h-9 w-9 rounded-full bg-black/25 flex items-center justify-center">
                    <MotionIcon>{item.icon}</MotionIcon>
                  </div>
                </div>

                <div className="mt-5 space-y-1">
                  <h3 className="text-base sm:text-lg font-semibold">{item.title}</h3>
                  <p className="text-white/90 text-sm sm:text-base leading-relaxed">{item.body}</p>
                </div>
              </MotionCard>
            ))}
          </div>
        </div>
      </div>
    </MotionSection>
  )
}
